export default __webpack_public_path__ + "static/media/MangammaLovelace.79e755be.png";